// this file added by Bearer Web Developer
import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import formatSecondsToMMSS from '../../../cancelOrderPopupContents/formatSecondsToMMSS';
import { useAppState } from '../../../../../states/app-state';

const Timer: React.FC = observer(() => {
    const appState = useAppState();
    const searchRiderResponse = appState.selectedOrder?.searchRider?.SearchRiderResponse;
    let miliseconds = searchRiderResponse?.realtime_code === 7 ? (Date.now() - searchRiderResponse?.event_time_accepted_rider_arrived_to_origin_in_ms) : 0;
    let seconds = Math.floor(Math.max(0, Math.round(miliseconds) / 1000));
    const timer = useRef<HTMLSpanElement | null>(null);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const startTime = Date.now();
    const time = useRef<number>(Math.max(0, Math.round(miliseconds) / 1000));
    useEffect(() => {

        if (timer?.current) {
            intervalRef.current = setInterval(() => {
                time.current = Math.floor(Math.max(0, Math.round((Date.now() - startTime + miliseconds) / 1000)));
                if (timer.current) timer.current.textContent =
                    formatSecondsToMMSS(time.current);
            }, 1000);
        }
        return () => {
            // Cleanup code to run when the component unmounts
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [seconds])

    return (
        <span ref={timer}>{formatSecondsToMMSS(seconds)}</span>
    )
});
export default Timer;